<data-query-button-data-config [(componentData)]="componentData" (onQuerySelected)="selectQuery($event)"></data-query-button-data-config>
@if (selectedQuery && selectedQuery.id !== '-1') {
  <div class="grid-x add-column-container">
    <div class="cell small-8"><h3 class="no-margin-bottom">Columns</h3></div>
    <div class="cell small-4 text-right">
      <button title="Add Column" attr.aria-label="Add Column" class="button hollow small minor-margin-bottom" (click)="addColumn()">
        Add Column
      </button>
    </div>
  </div>
  <!--<div class="columns-list-container" dragula="column-mapper" [(dragulaModel)]="componentData.config.columns">-->
  <div class="columns-list-container" [cdkDropListData]="componentData.config.column" (cdkDropListDropped)="onDrop($event)">
    @for (column of componentData.config.columns; track column) {
      <column-item [column]="column" [properties]="selectedObject"
      (onDelete)="removeColumn($event)"></column-item>
    }
  </div>
}
<ng-template #loading>
  <div class="loading-container">
    <static-loader diameter="40"></static-loader>
  </div>
</ng-template>


